import React from "react";

export function ThankYouTestStandings({ rows, minViews, winner, p = "ty-test" }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid={`${p}-standings`}>
        <thead>
          <tr className="border-b-2 border-black text-left label-mono">
            <th className="py-2 pr-3">Design</th>
            <th className="py-2 pr-3">Views</th>
            <th className="py-2 pr-3 text-right">Taps</th>
            <th className="py-2 text-right">Tap rate</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.key} className="border-b border-zinc-200" data-testid={`${p}-row-${r.key}`}>
              <td className="py-2 pr-3 font-bold">
                {r.name}
                {winner === r.key && <span className="ml-2 bg-emerald-600 px-1 text-[10px] uppercase text-white" data-testid={`${p}-winner-badge`}>Winner</span>}
                {!winner && i === 0 && r.views > 0 && <span className="ml-2 border border-black px-1 text-[10px] uppercase" data-testid={`${p}-leading`}>Leading</span>}
              </td>
              <td className="py-2 pr-3">
                <div className="flex items-center gap-2">
                  <div className="h-2 w-24 border border-black bg-white">
                    <div className="h-full bg-black" style={{ width: `${Math.min(100, (100 * r.views) / minViews)}%` }} />
                  </div>
                  <span className="tabular-nums" data-testid={`${p}-${r.key}-views`}>{r.views} / {minViews}</span>
                </div>
              </td>
              <td className="py-2 pr-3 text-right tabular-nums">{r.taps}</td>
              <td className="py-2 text-right tabular-nums" data-testid={`${p}-${r.key}-rate`}>{r.tap_rate == null ? "—" : `${r.tap_rate}%`}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
